import React, { useEffect, useState } from 'react';
import { useLocation } from "react-router-dom";
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import { Button, Grid } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import http from "../services/httpService";
import {
    getDate, prospectDetailsPath, toHHMMSS, getTime,
    getDateTime, emailMask, investmentDetailsPath, maskMobile,
    searchFilter, handleSort
} from "../utils/varialbles";
import { useHistory } from "react-router-dom";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import toast from 'react-hot-toast';

const useStyles = makeStyles({
    root: {
        width: '100%',
        backgroundColor: "#F5F7FA",
        padding: "7px"
    },
    circle: {

        borderRadius: "100%",
        background: "#3f51b5",
        color: "#fff",
    }
});
function InvestmentProfile() {
    const location = useLocation();
    let history = useHistory();
    const classes = useStyles();
    const [showWindow, setShowWindow] = useState(true);

    const [investmentDetails, setInvestmeDetails] = useState([]);
    const [investmentDetailsDropDown, setinvestmentDetailsDropDown] = useState([]);
    const myparam = location.state;
    useEffect(() => {
        if (myparam && myparam.cust__id) {
            toast.loading("Please wait...");
            http.get("/investment_profile/" + myparam.cust__id).then(res => {
                toast.dismiss()
                if (res && res.data && res.data.data && Array.isArray(res.data.data) && res.data.data.length > 0) {
                    let newData = res.data.data;
                    // ('am log', res.data.data);
                    let group = newData.reduce((r, a) => {
                        r[a.attribute] = [...r[a.attribute] || [], a];
                        return r;
                    }, {});
                    let finalValues = Object.values(group)
                    setinvestmentDetailsDropDown(finalValues);
                    setInvestmeDetails(res.data.data);
                } else {
                    toast.error('This user hasn\'t completed their investor profile yet.');
                }
            }).catch(err => {

            })
        }
    }, [])
    const gotoProspectDetails = (e) => {
        e.preventDefault();
        if (myparam && myparam.cust__id) {
            history.push({
                "pathname": prospectDetailsPath, state: myparam
            });
        } else if (myparam && myparam.customer_id) {
            history.push({
                "pathname": investmentDetailsPath, state: myparam
            });
        }
    }
    return (<Grid container style={showWindow ? { display: "block" } : { display: "none" }}>

        <Paper className={classes.root}>
            <Grid container>
                <Grid item xs={12} sm={6} md={1}>
                    <Button name="Overview" variant="contained" color="primary" onClick={gotoProspectDetails}>Overview</Button>
                </Grid>
            </Grid>
        </Paper>
        <Grid container style={{ marginTop: "10px" }}>
            <Grid item xs={false} sm={6} md={4} style={{ marginTop: 30 }}>
                <Button variant="outlined" color="default" startIcon={<ArrowBackIosIcon />} onClick={gotoProspectDetails}>Back</Button>
            </Grid>
            <Grid item xs={false} sm={6} md={6} style={{ marginTop: 30 }}>
                <Typography color="textPrimary" variant="h5" >Investment Profile</Typography>
            </Grid>
        </Grid>
        <Grid container style={{ marginTop: "20px" }} className="personalProfile">

            {
                investmentDetailsDropDown.map((obj, inx) => {
                    return (
                        <Grid item xs={12} sm={4} md={4} key={inx} style={{ marginTop: "20px" }} >
                            {obj[0].attribute}
                            <Accordion style={{ width: "80%" }}>
                                {obj.sort((a, b) => { return new Date(b["updateddt"]) - new Date(a["updateddt"]) }).map((sub, index) => {
                                    return (
                                        <>
                                            {(obj.length > 1 && index === 0) ?

                                                <AccordionSummary expandIcon={<ExpandMoreIcon />} edge="start" key={index + sub.attribute.trim}>
                                                    <Typography variant="h6" >
                                                        {sub.attribute === "Mobile Number" ?
                                                            maskMobile(sub.custresponse) :
                                                            sub.attribute === "Email ID" ?
                                                                emailMask(sub.custresponse) :
                                                                sub.custresponse}
                                                    </Typography>
                                                </AccordionSummary>
                                                : (obj.length > 1 && index !== 0) ? <AccordionDetails key={index + sub.attribute.trim}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="body1" style={{ color: "#6e6e6e" }}>
                                                            {sub.attribute === "Mobile Number" ?
                                                                maskMobile(sub.custresponse) :
                                                                sub.attribute === "Email ID" ?
                                                                    emailMask(sub.custresponse) :
                                                                    sub.custresponse}
                                                        </Typography>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="body1" style={{ color: "#6e6e6e" }}>{getDate(sub.updateddt)}</Typography>
                                                    </Grid>
                                                </AccordionDetails> : (obj.length === 1 && index === 0) ? <AccordionDetails key={index + sub.attribute.trim}>
                                                    <Typography variant="body1" >
                                                        {sub.attribute === "Mobile Number" ?
                                                            maskMobile(sub.custresponse) :
                                                            sub.attribute === "Email ID" ?
                                                                emailMask(sub.custresponse) :
                                                                sub.custresponse}
                                                    </Typography>
                                                </AccordionDetails> : ""}
                                        </>
                                    )
                                })}
                            </Accordion>
                        </Grid>
                    )
                })
            }
        </Grid>
    </Grid>
    )
}

export default InvestmentProfile;